export const RoleOptions = {
  SUPERADMIN: 'SUPERADMIN',
  SUPPORT: 'SUPPORT',
  ACCOUNT_OWNER: 'ACCOUNT_OWNER',
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  EMPLOYEE: 'EMPLOYEE',
} as const;

export const Roles = Object.keys(RoleOptions) as (keyof typeof RoleOptions)[];

export type Role = (typeof Roles)[number];

// System-level roles (not tied to any account)
export const SystemRoleOptions = {
  SUPERADMIN: 'SUPERADMIN',
  SUPPORT: 'SUPPORT',
} as const;

export const SystemRoles = Object.keys(SystemRoleOptions) as (keyof typeof SystemRoleOptions)[];
export type SystemRole = (typeof SystemRoles)[number];

// Account-level roles (tied to membership)
export const MembershipRoleOptions = {
  ACCOUNT_OWNER: 'ACCOUNT_OWNER',
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  EMPLOYEE: 'EMPLOYEE',
} as const;

export const MembershipRoles = Object.keys(MembershipRoleOptions) as (keyof typeof MembershipRoleOptions)[];
export type MembershipRole = (typeof MembershipRoles)[number];